import axios from "axios";


export const updateManualPoints = async (data) => {
  try {
    const res = await axios.post(
      `/api/company/updateManualPoints`, data
    );
    return res;
  } catch (error) {
  }
};

export const getPointType = async (data) => {
  try {
    const res = await axios.get(
      `/api/Company/getPointType`
    );
    return res;
  } catch (error) {
  }
};
